/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {dlsTextColor} from '@ion/dls/src/theme/theme';

export interface MissingCountBannerProps {
  missingCount: number;
  totalCount: number;
}

const useStyles = makeStyles(() => ({
  banner : {
    boxSizing      : 'border-box',
    display        : 'flex',
    width          : '100%',
    justifyContent : 'flex-start',
    alignItems     : 'center',
    padding        : '0 16px',
    paddingTop     : '8px'
  },
  text : {
    fontFamily    : 'Inter',
    fontWeight    : 600,
    fontSize      : '10px',
    lineHeight    : '14px',
    letterSpacing : '0.5px',
    color         : dlsTextColor('red')
  }
}));

/**
 * MissingCountBanner renders the "X of Y Missing" red text banner shown
 * above the Assigned tag list (ION-7463) whenever one or more assigned tags
 * are currently out of range.
 *
 * ```typescript
 *
 *   import {MissingCountBanner} from
 *     '@ion/dls/src/components/assetdetails/current/MissingCountBanner';
 *   ...
 *
 *   <MissingCountBanner missingCount={1} totalCount={2} />
 *
 * ```
 *
 */
export const MissingCountBanner = ({missingCount, totalCount}: MissingCountBannerProps) => {
  const classes = useStyles();
  return (
    <div className={classes.banner}>
      <span className={classes.text}>
        {`${missingCount} of ${totalCount} Missing`}
      </span>
    </div>
  );
};

export default memo(MissingCountBanner);
